import departmentApi from '@/api/department';

const state = {
    departmentList: null,
    departmentCreated: null,
    departmentUpdated: null,
    isLoading: false,
    validationErrors: null,
    stock:null,
    listAllReceipts:null,
    receipt:null,
    suppliers:null
}

export const mutationTypes = {
    departmentListStart: '[department] List department start',
    departmentListSuccess: '[department] List department success',
    departmentListFailure: '[department] List department failure',

    departmentCreateStart: '[department] Create department start',
    departmentCreateSuccess: '[department] Create department success',
    departmentCreateFailure: '[department] Create department failure',

    departmentUpdateStart: '[department] Update department start',
    departmentUpdateSuccess: '[department] Update department success',
    departmentUpdateFailure: '[department] Update department failure',

    stockListStart: '[stock] Stock List start',
    stockListSuccess: '[stock] Stock List success',
    stockListFailure: '[stock] Stock List failure',

    getStockInfoStart: '[stock] Get Stock Info start',
    getStockInfoSuccess: '[stock] Get Stock Info success',
    getStockInfoFailure: '[stock] Get Stock Info failure',

    getReceiptsAllListStart: '[listAllReceipts] Get Receipts All List start',
    getReceiptsAllListSuccess: '[listAllReceipts] Get Receipts All List success',
    getReceiptsAllListFailure: '[listAllReceipts] Get Receipts All List failure',

    updateReceiptStart: '[receipt] Update receipt start',
    updateReceiptSuccess: '[receipt] Update receipt success',
    updateReceiptFailure: '[receipt] Update receipt failure',

    createReceiptStart: '[receipt] Create receipt start',
    createReceiptSuccess: '[receipt] Create receipt success',
    createReceiptFailure: '[receipt] Create receipt failure',

    getStockSuppliersStart: '[suppliers] Get Stock Suppliers start',
    getStockSuppliersSuccess: '[suppliers] Get Stock Suppliers success',
    getStockSuppliersFailure: '[suppliers] Get Stock Suppliers failure',
    
}

export const departmentActionTypes = {
    departmentList: '[department] List department',
    departmentFullList: '[department] Full list department',
    departmentCreate: '[department] Create department',
    departmentUpdate: '[department] Update department',
    stockList: '[stock] Stock List',
    getStockInfo: '[stock] Get Stock Info',
    getReceiptsAllList: '[listAllReceipts] Get Receipts All List',
    updateReceipt: '[receipt] Update receipt',
    createReceipt: '[receipt] Create receipt',
    getStockSuppliers: '[suppliers] Get Stock Suppliers'
}

const mutations = {
    [mutationTypes.departmentListStart](state) {
        state.isLoading = true
        state.departmentList = null
    },
    [mutationTypes.departmentListSuccess](state, payload) {
        state.isLoading = false
        state.departmentList = payload
        state.validationErrors = null
    },
    [mutationTypes.departmentListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.departmentCreateStart](state) {
        state.isLoading = true
        state.departmentCreated = null
    },
    [mutationTypes.departmentCreateSuccess](state, payload) {
        state.isLoading = false
        state.departmentCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.departmentCreateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.departmentUpdateStart](state) {
        state.isLoading = true
        state.departmentUpdated = null
    },
    [mutationTypes.departmentUpdateSuccess](state, payload) {
        state.isLoading = false
        state.departmentUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.departmentUpdateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.stockListStart](state) {
        state.isLoading = true
        state.stock = null
    },
    [mutationTypes.stockListSuccess](state, payload) {
        state.isLoading = false
        state.stock = payload
        state.validationErrors = null
    },
    [mutationTypes.stockListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
    //stock-receipts-----------------------------------------
    [mutationTypes.getStockInfoStart](state) {
        state.isLoading = true
        state.stock = null
    },
    [mutationTypes.getStockInfoSuccess](state, payload) {
        state.isLoading = false
        state.stock = payload
        state.validationErrors = null
    },
    [mutationTypes.getStockInfoFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getReceiptsAllListStart](state) {
        state.isLoading = true
        state.listAllReceipts = null
    },
    [mutationTypes.getReceiptsAllListSuccess](state, payload) {
        state.isLoading = false
        state.listAllReceipts = payload
        state.validationErrors = null
    },
    [mutationTypes.getReceiptsAllListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.updateReceiptStart](state) {
        state.isLoading = true
        state.receipt = null
    },
    [mutationTypes.updateReceiptSuccess](state, payload) {
        state.isLoading = false
        state.receipt = payload
        state.validationErrors = null
    },
    [mutationTypes.updateReceiptFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.createReceiptStart](state) {
        state.isLoading = true
        state.receipt = null
    },
    [mutationTypes.createReceiptSuccess](state, payload) {
        state.isLoading = false
        state.receipt = payload
        state.validationErrors = null
    },
    [mutationTypes.createReceiptFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getStockSuppliersStart](state) {
        state.isLoading = true
        state.suppliers = null
    },
    [mutationTypes.getStockSuppliersSuccess](state, payload) {
        state.isLoading = false
        state.suppliers = payload
        state.validationErrors = null
    },
    [mutationTypes.getStockSuppliersFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    

}

const actions = {
    [departmentActionTypes.departmentList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.departmentListStart)
            departmentApi
                .departmentList(data)
                .then(response => {
                    context.commit(mutationTypes.departmentListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.departmentListFailure,response)
                })
        })
    },
    [departmentActionTypes.departmentCreate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.departmentCreateStart)
            departmentApi
                .departmentCreate(data)
                .then(response => {
                    context.commit(mutationTypes.departmentCreateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.departmentCreateFailure,response)
                })
        })
    },
    [departmentActionTypes.departmentUpdate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.departmentUpdateStart)
            departmentApi
                .departmentUpdate(data)
                .then(response => {
                    context.commit(mutationTypes.departmentUpdateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.departmentUpdateFailure,response)
                })
        })
    },
    //receipts ------------------------------------------------------------------------------------------------------------
    [departmentActionTypes.stockList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.stockListStart)
            departmentApi
                .stockList(data)
                .then(response => {
                    context.commit(mutationTypes.stockListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.stockListFailure,response)
                })
        })
    }, 
    [departmentActionTypes.getStockInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getStockInfoStart)
            departmentApi
                .getStockInfo(data)
                .then(response => {
                    context.commit(mutationTypes.getStockInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getStockInfoFailure,response)
                })
        })
    }, 
    [departmentActionTypes.getReceiptsAllList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getReceiptsAllListStart)
            departmentApi
                .getReceiptsAllList(data)
                .then(response => {
                    context.commit(mutationTypes.getReceiptsAllListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getReceiptsAllListFailure,response)
                })
        })
    }, 
    [departmentActionTypes.updateReceipt](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.updateReceiptStart)
            departmentApi
                .updateReceipt(data)
                .then(response => {
                    context.commit(mutationTypes.updateReceiptSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.updateReceiptFailure,response)
                })
        })
    }, 
    [departmentActionTypes.createReceipt](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createReceiptStart)
            departmentApi
                .createReceipt(data)
                .then(response => {
                    context.commit(mutationTypes.createReceiptSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createReceiptFailure,response)
                })
        })
    }, 
    [departmentActionTypes.getStockSuppliers](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getStockSuppliersStart)
            departmentApi
                .getStockSuppliers(data)
                .then(response => {
                    context.commit(mutationTypes.getStockSuppliersSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getStockSuppliersFailure,response)
                })
        })
    }, 
    

}

export default {
    state,
    actions,
    mutations
}